<template>
  <div class="auth-layout">
    <div class="auth-bg-glow auth-bg-glow--cyan" />
    <div class="auth-bg-glow auth-bg-glow--coral" />
    <div class="auth-content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.auth-layout {
  position: relative;
  min-height: 100vh;
  background-color: var(--bg-color);
  color: var(--text-main);
  overflow: hidden;
}

.auth-bg-glow {
  position: absolute;
  width: 600px;
  height: 600px;
  border-radius: 50%;
  filter: blur(150px);
  opacity: 0.08;
  pointer-events: none;
  animation: float 20s ease-in-out infinite;
}

.auth-bg-glow--cyan {
  background: var(--primary);
  top: -200px;
  right: -100px;
}

.auth-bg-glow--coral {
  background: #ff6b6b;
  bottom: -200px;
  left: -100px;
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(30px, 20px); }
  50% { transform: translate(-20px, 40px); }
  75% { transform: translate(20px, -10px); }
}

.auth-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 1rem;
}
</style>
